<template>
  <div class="box">
    <!-- Gamesamba 公共头部-->
    <GameSambaHeader></GameSambaHeader>

    <div class="part-main" @click="closeLanguageBorder">
      <div class="part1 pc blur-container">
        <video src="~@/assets/images/english/smooth.mp4" loop autoplay muted></video>
        <!-- 头部 -->
        <Header></Header>

        <!-- 主要内容 -->
        <div class="main-contain">
          <!-- 标题内容 -->
          <div class="title-content">
            <!-- 标题 -->
            <div class="title">
              <img :src="require(`@/assets/images/english/pc/part1/title.png`)" alt="" />
            </div>
            <div class="store-appointment">
              <a
                href="https://apps.apple.com/us/app/tokyo-ghoul-break-the-chains/id6472877362"
                target="app"
              >
                <img :src="require(`@/assets/images/${language}/apple.png`)" alt="" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.funcat.tgbtcar&hl=en_US"
                target="google"
              >
                <img :src="require(`@/assets/images/${language}/google.png`)" alt="" />
              </a>
            </div>
          </div>
          <!-- 语言选择 -->
          <div class="language">
            <div class="language-border" v-show="showLanguage">
              <p @click="changeLanguage('alabo')">العربية</p>
              <p @click="changeLanguage('english')">English</p>
            </div>
            <div class="language-selected" @click="selectedLanguage">
              <img src="~@/assets/images/english/pc/part1/language.png" alt="" /><span>{{
                home.languageTitle
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="yd">
        <!-- 头部 -->
        <Header></Header>
        <!-- 主要内容 -->
        <div class="main-contain">
          <!-- 语言选择 -->
          <div class="language">
            <div class="language-border" v-show="showLanguage">
              <p @click="changeLanguage('alabo')">العربية</p>
              <p @click="changeLanguage('english')">English</p>
            </div>
            <div class="language-selected" @click="selectedLanguage">
              <img src="~@/assets/images/english/pc/part1/language.png" alt="" /><span>{{
                home.languageTitle
              }}</span>
            </div>
          </div>

          <!-- 标题 -->
          <div class="title">
            <img :src="require(`@/assets/images/english/mob/part1/title.png`)" alt="" />
          </div>
          <!-- 商店按钮 -->
          <div class="store-appointment">
            <a
              href="https://apps.apple.com/us/app/tokyo-ghoul-break-the-chains/id6472877362"
              target="app"
            >
              <img :src="require(`@/assets/images/${language}/apple.png`)" alt="" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.funcat.tgbtcar&hl=en_US"
              target="google"
            >
              <img :src="require(`@/assets/images/${language}/google.png`)" alt="" />
            </a>
          </div>

          <!-- 预注册奖励 -->
          <div class="reward">
            <img
              :src="require(`@/assets/images/${language}/mob/part1/reward.png`)"
              alt=""
            />
            <!-- 奖励文字 -->
            <div class="reward-text" v-if="language === 'english'">
              <span>Coin×50k</span>
              <span>Summon Ticket×10</span>
              <span>Reserve Exclusive Avatar Frame</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./header.vue";
import GameSambaHeader from "./gamesamba_header.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      showLanguage: false,
      showappMask: false,
      showgoogleMask: false,
    };
  },
  components: {
    Header,
    GameSambaHeader,
  },
  computed: {
    ...mapState(["language", "home"]), // 在这里引入你需要的state值
  },
  methods: {
    // 切换语言
    changeLanguage(newLanguage) {
      this.$cookieStore.addCookie("language", newLanguage, 1);
      setTimeout(() => {
        location.reload(); // 刷新页面
      }, 300);
    },
    //点击语言，语言边框显示或隐藏
    selectedLanguage() {
      this.showLanguage = !this.showLanguage;
    },
    // 点击app商店按钮跳出弹框
    changeAppMask() {
      this.showappMask = !this.showappMask;
    },
    // 点击谷歌商店按钮跳出弹框
    changeGoogleMask() {
      this.showgoogleMask = !this.showgoogleMask;
    },
    //点击非语言区域，语言边框进行隐藏
    closeLanguageBorder() {
      if (!event.target.closest(".language")) {
        this.showLanguage = false;
      }
    },
  },
  mounted() {
    this.$bus.$on("openApp", () => {
      this.showappMask = !this.showappMask;
    });

    this.$bus.$on("openGoogle", () => {
      this.showgoogleMask = !this.showgoogleMask;
    });

    let lang = this.$route.query.lang;
    if (lang == "english") {
      this.$cookieStore.addCookie("language", "english", 1);
      this.$router.push('/');
    }
    if (lang == "alabo") {

      this.$cookieStore.addCookie("language", "alabo", 1);
      this.$router.push('/');
    }
    if (lang == "") {
      this.$cookieStore.addCookie("language", "english", 1);
    }
    console.log(lang);
    console.log(this.$cookieStore.getCookie("language"));
  },
  created() {},
};
</script>

<style lang="less" scoped>
.part-main {
  width: 100%;
  height: 1080px;
  position: relative;
  top: 78px;
}

.part1 {
  background: url(~@/assets/images/english/pc/part1/bg.jpg) center no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: relative;

  .main-characters {
    position: absolute;
    left: 50%;
    top: 9.7%;
    transform: scale(0.95) translate(-58%);
  }

  .minor-characters {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%);
  }

  .title {
    position: absolute;
    top: 49%;
    left: 49.5%;
    transform: translate(-50%);
  }

  .pregister {
    position: absolute;
    top: 65%;
    left: 50%;
    transform: translate(-50%);
    cursor: pointer;
  }

  .pre-register {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .store-appointment {
    position: absolute;
    left: 35.5%;
    top: 70%;
    z-index: 98;

    > a {
      margin-right: 50px;
    }
  }
}

.language {
  position: absolute;
  right: 10%;
  z-index: 9;
  top: 3%;

  .language-selected {
    width: 208px;
    height: 58px;
    background-color: rgb(10, 10, 11);
    /* opacity: 0; */
    text-align: center;
    line-height: 58px;
    font-size: 30px;
    color: rgb(220, 220, 220);
    font-family: serif;
    font-weight: bold;
    cursor: pointer;

    > img {
      margin-bottom: 5px;
      margin-right: 5px;
      transform: scale(1.1);
    }

    &:hover {
      background: url(~@/assets/images/english/pc/part1/language-button.png) center
        no-repeat;
    }
  }

  .language-border {
    background: url(data:image/png;base64,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)
      center no-repeat;
    width: 208px;
    height: 131px;
    position: absolute;
    transition: opacity 0.3s ease;
    top: 100%;

    > p {
      color: rgb(220, 220, 220);
      text-align: center;
      line-height: 58px;
      font-size: 25px;
      font-family: serif;
      font-weight: bold;
      cursor: pointer;

      &:hover {
        text-shadow: 0 0 5px rgb(255, 0, 0);
      }
    }
  }
}

.mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  display: block;

  .pre_con {
    width: 680px;
    height: 434px;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    background: url(~@/assets/images/english/pc/part1/mask-bg.png) no-repeat;
    background-size: 100% 100%;

    .pre_close {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }

    .q1 {
      font-size: 16px;
      width: 600px;
      height: 50px;
      line-height: 50px;
      color: #fff;
      text-align: center;
      position: absolute;
      left: 0;
      top: 125px;

      .apptitle {
        position: absolute;
        bottom: 80px;
        font-size: 40px;
        left: 46%;
      }

      p {
        font-size: 20px;
        width: 100%;
        margin-left: 40px;
        margin-top: 10%;
      }

      span button {
        width: 100%;
        height: 100%;
        background-color: rgb(245, 118, 14);
        border-radius: 5px;
        border-style: none;
        color: rgb(236, 230, 230);
        font-size: 16px;
      }
    }
  }
}

@media screen and (max-width: 980px) {

  .box {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .part-main {
    height: 1250px;
    width: 626px;
    top:0px;

    .title {
      position: absolute;
      top: 48%;
      left: 40%;
      transform: scale(0.8) translate(-50%);
    }

    .reward {
      position: absolute;
      top: 78%;
      left: 40%;
      transform: scale(0.8) translate(-50%);

      .reward-text {
        position: absolute;
        left: 16.5%;
        top: 73.8%;
        color: rgb(255, 255, 255);
        font-size: 16px;

        > span {
          margin-right: 108px;

          &:nth-child(2) {
            width: 55px;
            display: inline-flex;
            margin-right: 88px;
          }

          &:nth-child(3) {
            display: inline-flex;
            width: 158px;
            text-align: center;
            margin-right: 0px;
          }
        }
      }
    }


    .language {
      position: absolute;
      right: 10%;
      z-index: 9;
      top: 0.75%;

      .language-selected {
        transform: scale(0.85);
      }

      .language-border {
        transform: scale(0.85);
        top: 80%;
      }
    }

    .store-appointment {
      position: absolute;
      left: 13.2%;
      top: 66.8%;
      z-index: 98;

      > a {
        margin-right: 18px;

        > img {
          width: 218px;
        }
      }
    }

    .pre_con {
      transform: translateX(-50%) translateY(-50%) scale(0.85);
    }
  }
}
</style>
